import { ReactNode } from 'react';
import { Button, Typography } from '@idu-nightlife/ui-kit';
import { ArrowForward } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { SimpleDialog } from '../simple-dialog/simple-dialog';

export type ConfirmDialogProps = {
  open: boolean;
  title?: ReactNode;
  children?: ReactNode;
  cancelLabel?: string;
  submitLabel?: string;
  onCancel?: () => void;
  onSubmit?: () => void;
  cancelDisabled?: boolean;
  submitDisabled?: boolean;
  submitEndIcon?: ReactNode;
  submitStartIcon?: ReactNode;
  disableDefaultEndIcon?: boolean;
  submitColor?: 'primary' | 'error' | 'warning';
};

export const ConfirmDialog = ({
  open,
  title = 'Dialog',
  children,
  cancelLabel = 'Cancel',
  submitLabel = 'Continue',
  onCancel,
  onSubmit,
  cancelDisabled = false,
  submitDisabled = false,
  disableDefaultEndIcon = false,
  submitEndIcon = !disableDefaultEndIcon && <ArrowForward />,
  submitStartIcon,
  submitColor = 'primary',
}: ConfirmDialogProps) => {
  return (
    <SimpleDialog
      open={open}
      fullWidth={false}
      slotProps={{ paper: { sx: { boxShadow: 24, m: { xs: 2, md: 6 } } } }}
    >
      <SimpleDialog.Title
        sx={{
          px: 2,
          height: 48,
          display: 'flex',
          alignItems: 'center',
          color: 'primary.main',
          borderBottom: '1px solid',
          backgroundColor: 'primary.light',
          borderColor: 'primary.separator',
        }}
      >
        <Typography.Subheading component="span">{title}</Typography.Subheading>
      </SimpleDialog.Title>

      <SimpleDialog.Content
        sx={{
          my: 2,
          py: 0,
          minHeight: 80,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {children}
      </SimpleDialog.Content>

      <SimpleDialog.Actions sx={{ px: 2, py: 0, height: 60 }}>
        <Stack direction="row" sx={{ width: '100%', gap: 1 }}>
          <Button sx={{ flex: 1 }} onClick={onCancel} variant="secondary" disabled={cancelDisabled}>
            {cancelLabel}
          </Button>

          <Button
            sx={{ flex: 1 }}
            onClick={onSubmit}
            variant="primary"
            color={submitColor}
            endIcon={submitEndIcon}
            startIcon={submitStartIcon}
            disabled={submitDisabled}
          >
            {submitLabel}
          </Button>
        </Stack>
      </SimpleDialog.Actions>
    </SimpleDialog>
  );
};

export default ConfirmDialog;
